import { defineStore } from 'pinia'
import { ref } from 'vue'
import { applyTenantLabelOverrides, resetTenantLabelOverrides } from '@/config/i18n'
import { fetchLabelOverrides } from '@/services/labels.service'

export const useLabelOverridesStore = defineStore('labelOverrides', () => {
  const loaded = ref(false)
  let inflight: Promise<void> | null = null

  /**
   * Load and apply tenant label overrides once per session.
   * Failures are already swallowed by the service, so the shipped bundles stay in use.
   */
  async function load(force = false): Promise<void> {
    if (inflight) return inflight
    if (loaded.value && !force) return

    inflight = (async () => {
      const payload = await fetchLabelOverrides()
      if (payload) {
        applyTenantLabelOverrides(payload.labels ?? {})
        loaded.value = true
      }
    })()

    try {
      await inflight
    } finally {
      inflight = null
    }
  }

  /** Restore shipped labels (logout / tenant switch). Next load refetches. */
  function reset(): void {
    resetTenantLabelOverrides()
    loaded.value = false
  }

  return { loaded, load, reset }
})
